const gray = {
  0: "#ffffff",
  50: "#f0f0f0",
  100: "#e9e9e9",
  150: "#dddddd",
  200: "#d7d7d7",
  250: "#c8c8c8",
  300: "#bfbfbf",
  350: "#a6a6a6",
  400: "#999999",
  450: "#8c8c8c",
  500: "#808080",
  550: "#666666",
  600: "#5b5b5b",
  650: "#595959",
  700: "#444444",
  750: "#414141",
  800: "#333333",
  850: "#242424",
  900: "#222222",
  950: "#101010",
  1000: "#000000",
};

const yellow = {
  200: "#f7d681",
  300: "#ffc74f",
  350: "#f3be43",
  450: "#f0ac0f",
};

const green = {
  50: "#e4f5d7",
  350: "#94e35d",
  600: "#00b62d",
};

const smokeGreen = {
  400: "#73a982",
};

const red = {
  0: "#ffe2e2",
  50: "#ffd8d2",
  100: "#ffbdb3",
  200: "#ff8d7e",
  250: "#ff5a5a",
  450: "#ff0000",
  650: "#990000",
};

const smokeRed = {
  150: "#e9b4ac",
  300: "#e96161",
};

const blue = {
  0: "#e2f0ff",
  50: "#bbe4ff",
  350: "#2986ff",
  450: "#001dff",
};

const lightBlue = {
  450: "#1ddfee",
};

const smokeBlue = {
  0: "#eff1f7",
  200: "#abc1cf",
  500: "#2c79bd",
};

const purple = {
  50: "#F5EDFF",
  200: "#D4AAFF",
  300: "#B388FF",
  450: "#E5D0FF",
};

const primer = {
  canvas: "#0d1117",
  surface: "#161b22",
  overlay: "#1c2128",
  muted: "#21262d",
  border: "#30363d",
  fg: "#e6edf3",
  fgMuted: "#8b949e",
  fgSubtle: "#6e7681",
  accent: "#388bfd",
  danger: "#f85149",
  success: "#3fb950",
  attention: "#d29922",
  purple: "#bc8cff",
};

export default {
  gray,
  yellow,
  green,
  smokeGreen,
  red,
  smokeRed,
  blue,
  lightBlue,
  smokeBlue,
  purple,
  primer,
};

// https://www.w3schools.com/colors/colors_picker.asp
// 명도 기준 ((100% - (5단위로 가까운 %) / 5%) - 1) * 50
